import { gtmIntegration } from './gtm';
import { manualJsIntegration } from './manualJs';
import { serverSideIntegration } from './serverSide';
import { shopifyIntegration } from './shopify';
import { squarespaceIntegration } from './squarespace';
import type { PixelIntegration } from './types';
import { wixIntegration } from './wix';
import { wooCommerceIntegration } from './woocommerce';
import { wordpressIntegration } from './wordpress';

/**
 * Registry of pixel integration platforms. Add a new tab by:
 *   1. creating a new file in this folder that exports a {@link PixelIntegration}
 *   2. adding it to the array below (order = nav order)
 * The {@link IntegrationGuide} component handles all rendering — no UI changes needed.
 */
export const PIXEL_INTEGRATIONS: PixelIntegration[] = [
  manualJsIntegration,
  gtmIntegration,
  shopifyIntegration,
  wordpressIntegration,
  wooCommerceIntegration,
  wixIntegration,
  squarespaceIntegration,
  serverSideIntegration,
];

export type { PixelIntegration, IntegrationContext, IntegrationSnippet } from './types';
